export default __webpack_public_path__ + "static/media/Maskgroup6.0dfd4cc8.svg";